import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { hasSubmitSucceeded, isDirty, reset } from 'redux-form';
import { Button, ButtonContainer } from 'components/button';
import { EDIT_MY_VIDEO_FORM } from '../';

const mapStateToProps = (state) => ({
  isDirty: isDirty(EDIT_MY_VIDEO_FORM)(state),
  formSubmitted: hasSubmitSucceeded(EDIT_MY_VIDEO_FORM)(state),
});

const mapDispatchToProps = (dispatch) => ({
  onDiscard: () => dispatch(reset(EDIT_MY_VIDEO_FORM)),
});

const FormControls = ({ onDiscard, isDirty, formSubmitted }) => {
  const { t } = useTranslation();
  return (
    <div className="row no-gutters">
      <div className="col-sm-4 col-xs-12">* {t('mandatory_fields')}</div>
      <div className="col-sm-8 col-xs-12 mt-2 mt-sm-0">
        <ButtonContainer>
          <Button onClick={onDiscard} secondary={true} disabled={!isDirty || formSubmitted}>
            {t('discard_changes')}
          </Button>
          <Button disabled={!isDirty || formSubmitted} type="submit">
            {t('save')}
          </Button>
        </ButtonContainer>
      </div>
    </div>
  );
};

export const FormControlsDecorated = connect(mapStateToProps, mapDispatchToProps)(FormControls);
